import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  fetchCopyPto,
  fetchRestrictedLocations,
  sendCreatePto,
  updateCreatePtoField,
} from '../store/createOrder';
import {
  currentAffiliateSelector,
  fetchAffiliates,
  getAffiliatesOptions,
} from '../store/affiliates';
import {
  fetchOriginatorLocations,
  getOriginatorLocationsOptions,
} from '../store/originatorLocations';
import {
  fetchOriginatorLocationProducts,
  originatorLocationProductOptionsSelector,
} from '../store/originatorLocationProducts';
import {
  fetchOriginatorLocationProductReidVaporPressures,
  getOriginatorLocationRvpOptions,
  resetOriginatorLocationProductReidVaporPressures,
} from '../store/originatorLocationProductReidVaporPressures';
import {
  fetchOriginatorLocationProductOrigins,
  getOriginatorLocationProductOriginsError,
} from '../store/originatorLocationProductOrigins';
import { fetchOriginatorLocationProductBalances } from '../store/originatorLocationProductBalances';
import CreatePtoWizard from './CreateWizard';

const mapState = state => ({
  affiliateOptions: getAffiliatesOptions(state),
  affiliates: state.pto.affiliates.affiliatesList,
  affiliatesError: state.pto.affiliates.error,
  createPtoData: state.pto.createPto,
  currentAffiliate: currentAffiliateSelector(state),
  openPtos: state.pto.openPtos.openPtoList,
  originatorLocationOptions: getOriginatorLocationsOptions(state),
  originatorLocationProductBalances:
    state.pto.originatorLocationProductBalances.originatorLocationProductBalances,
  originatorLocationProductBalancesError: state.pto.originatorLocationProductBalances.error,
  originatorLocationProductBalancesPending: state.pto.originatorLocationProductBalances.pending,
  originatorLocationProductOrigins:
    state.pto.originatorLocationProductOrigins.originatorLocationProductOriginsList,
  originatorLocationProductOriginsError: getOriginatorLocationProductOriginsError(state),
  originatorLocationProductOriginsPending: state.pto.originatorLocationProductOrigins.pending,
  originatorLocationProductReidVaporPressuresError:
    state.pto.originatorLocationProductReidVaporPressures.error,
  originatorLocationProductReidVaporPressuresOptions: getOriginatorLocationRvpOptions(state),
  originatorLocationProductReidVaporPressuresPending:
    state.pto.originatorLocationProductReidVaporPressures.fetchPending,
  originatorLocationProducts: state.pto.originatorLocationProducts.originatorLocationProductsList,
  originatorLocationProductsError: state.pto.originatorLocationProducts.error,
  originatorLocationProductsOptions: originatorLocationProductOptionsSelector(state),
  originatorLocationProductsPending: state.pto.originatorLocationProducts.pending,
  originatorLocations: state.pto.originatorLocations.originatorLocationsList,
  originatorLocationsError: state.pto.originatorLocations.error,
  restrictedLocations: state.pto.createPto.restrictedLocations,
  restrictedLocationsPending: state.pto.createPto.restrictedLocationsPending,
  sendError: state.pto.createPto.sendError,
  sendPending: state.pto.createPto.sendPending,
});

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      fetchAffiliates,
      fetchCopyPto,
      fetchOriginatorLocationProductBalances,
      fetchOriginatorLocationProductOrigins,
      fetchOriginatorLocationProductReidVaporPressures,
      fetchOriginatorLocationProducts,
      fetchOriginatorLocations,
      fetchRestrictedLocations,
      resetOriginatorLocationProductReidVaporPressures,
      sendCreatePto,
      updateCreatePtoField,
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(CreatePtoWizard);
